const formatter = new Intl.NumberFormat("ru-RU");

export function formatNumber(n: number): string {
  return formatter.format(n);
}
